import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Sidebar from '../Sidebar/Sidebar';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import styles from './Layout.module.css';

const Layout: React.FC = () => {
  const { isLoggedIn } = useAuth();
  const { i18n } = useTranslation();
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);
  
  // Set direction to rtl if the language is Hebrew
  const contentDirection = i18n.language === 'he' ? 'rtl' : 'ltr';

  return (
    <div className={styles.container}>
      <Header onSidebarToggle={toggleSidebar} />
      <div dir={contentDirection} className={styles.contentWrapper}>
        {isLoggedIn && <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />}
        <main className={styles.mainContent}>
          <Outlet />
        </main>
      </div>
      <div dir={contentDirection}>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;